<template>
  <v-list-item @click="emitOnOpen" :class="`file-wrapper-${themeName} ${isSelected ? 'selected-' + themeName : ''}`">
    <v-list-item-avatar>
      <v-icon class="mt-2">{{ openInternally ? 'mdi-open-in-app' : 'mdi-web' }}</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>{{ item.title }}</v-list-item-title>
      <v-list-item-subtitle>{{ item.url }}</v-list-item-subtitle>
      <v-list-item-subtitle v-if="openInternally">
        {{ $t('weblink.openInsideApp') }}
      </v-list-item-subtitle>
      <v-list-item-subtitle v-else>{{ 'in neuem Browser öffnen' }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="openInternally" @click.stop="emitOnOpenExternally">
      <v-list-item-action-text color="secondary">{{ $t('weblink.openExternally') }}</v-list-item-action-text>

      <v-icon color="secondary">
        {{ openInternally ? 'mdi-web' : 'mdi-open-in-app' }}
      </v-icon>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import common from '@/mixins/common';

export default {
  name: 'WeblinkItem',
  mixins: [common],

  props: {
    item: Object,
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isYoutube() {
      return this.item.url.includes('https://youtu.be/') || this.item.url.includes('youtube.com');
    },
    openInternally() {
      return this.item.intern === 1 && this.isYoutube;
    },
  },
  methods: {
    emitOnOpen() {
      if (this.openInternally) {
        this.$emit('onOpenInternally');
      } else {
        this.$emit('onOpenExternally');
      }
    },
    emitOnOpenExternally() {
      this.$emit('onOpenExternally');
    },
  },
};
</script>

<style scoped>
/* NO SELECTION + HIGHLIGHT COLOR ==> avoids copy/paste functions which is inappropriate on smart phones*/

.selected-dark {
  background: #101010 !important;
}

.selected-light {
  background: #e0e0e0 !important;
}
</style>
